/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from "react";
import { StoryWrapper } from "../story-wrapper";

export const VideoStory = props => {
  return <StoryWrapper {...props} />;
};

VideoStory.defaultProps = {
  storyStoreField: "story",
  storyPageType: "video-story"
};
export default VideoStory;
